var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgBlobPadlock = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M60.5271 32.3583C64.1438 38.5019 65.0402 45.4818 62.7219 49.9528C60.4035 54.4559 54.9012 56.4502 49.7081 58.9912C44.5149 61.5323 39.6309 64.6524 34.2832 63.8804C28.9046 63.1084 23.0314 58.4123 23.0005 53.6518C22.9387 48.8913 28.7191 44.0665 33.2013 37.6977C37.7144 31.329 40.991 23.4806 45.7823 22.194C50.5736 20.9074 56.9105 26.2147 60.5271 32.3583Z",
    fill: "#FA7B6A"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.09961 29.1001H54.8996V54.9001H9.09961V29.1001ZM10.8996 30.9001V53.1001H53.0996V30.9001H10.8996Z",
    fill: "#1C1C1C"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M31.9995 10.9001C27.1998 10.9001 22.1404 13.1612 19.4103 17.1729C17.4636 20.0335 16.9522 23.8061 16.9036 29.1001H47.0947C47.037 23.922 46.4525 20.0092 44.5808 17.1608C41.8619 13.0232 36.8985 10.9001 31.9995 10.9001ZM17.9222 16.1603C21.0412 11.577 26.7064 9.1001 31.9995 9.1001C37.3643 9.1001 42.963 11.4212 46.0851 16.1723C48.3823 19.6683 48.8996 24.3567 48.8996 30.0001V30.9001H15.0996V30.0001C15.0996 24.243 15.5239 19.6845 17.9222 16.1603Z",
    fill: "#1C1C1C"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgBlobPadlock);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/BlobPadlock.f5cae29eb19ab322b7f28f573c61614e.svg";